export const DB_fieldName = "Sections";

export const formFields = [
    { label: "Section Name", size: "M", fieldVal: "secName", fieldType: "Text" },
    { label: "Section Number", size: "M", fieldVal: "secNumber", fieldType: "Text" },
    { label: "Order", size: "M", fieldVal: "secOrder", fieldType: "Text" },
]

export const tbColumns = [
    { id: 'secName', label: 'Section Name', minWidth: 130, minWidth: 150 },
    { id: 'secNumber', label: 'Section Number', minWidth: 100 },
    { id: 'secOrder', label: 'Order', minWidth: 100 },
    { id: 'action', label: 'Action', minWidth: 100 },
]